import diacritics from 'diacritics';
import { strlen } from 'fbjs/lib/UnicodeUtils';

var getWordAt = function getWordAt(regex, string, position) {
  var str = String(string);
  var pos = Number(position) >>> 0;
  var match = str.slice(0, pos).match(regex);

  if (!match) {
    return {
      searchWord: ''
    };
  } else if (match.length > 2) {
    throw new Error('Only one capture group is supported');
  }

  var begin = match.index + match[0].indexOf(match[1]);
  return {
    searchWord: match[1],
    begin: begin,
    end: begin + strlen(match[1])
  };
};

export var getSearchText = function getSearchText(regexp, value) {
  var selection = value.selection,
      startText = value.startText;
  var text = startText.text;
  var start = selection.start;
  var string = text.slice(0, start.offset); // transform accent chars

  string = diacritics.remove(string);

  var _getWordAt = getWordAt(regexp, string, start.offset),
      searchWord = _getWordAt.searchWord,
      begin = _getWordAt.begin,
      end = _getWordAt.end;

  return {
    searchWord: searchWord,
    begin: begin,
    end: end
  };
};
export var scanUntilAtSign = /(?:[\s()[\]{}]|^)(@[^\s@]{0,20}[\s]?[^\s@]{0,20}[\s]?[^\s@]{0,20})$/;
export var scanUntilSlash = /(?:[\s()[\]{}]|^)(\/[^\s/]{0,20})$/;
export var scanUntilColon = /(?:[\s()[\]{}]|^)(:[^\s]{0,20})$/;
export default getSearchText;